import { ChangeDetectionStrategy, Component, HostBinding, input, computed } from '@angular/core';
import { ImageModule } from 'primeng/image';

import { ImageLoading } from '@ppg/core/enums';
import { PageGeneralContent } from '@ppg/core/models';
import { SharedComponentRendererComponent } from '@ppg/features/shared-component-renderer';
import { HeroBannerComponent } from '@ppg/shared/components';
import { applyRichTextFixes } from '@ppg/shared/utils';

@Component({
  selector: 'ppg-general',
  standalone: true,
  imports: [SharedComponentRendererComponent, ImageModule, HeroBannerComponent],
  templateUrl: './general.component.html',
  styleUrl: './general.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GeneralComponent {
  @HostBinding('class.page-content') private readonly pageContentClass = true;

  readonly content = input.required<PageGeneralContent>();

  readonly imageLoading = ImageLoading;

  readonly mainSection = computed(() => {
    const content = this.content();
    const mainContentArea = applyRichTextFixes(content.mainContentArea);
    const sidebarArea = applyRichTextFixes(content.sidebarArea);

    if (!mainContentArea?.length && !sidebarArea?.length) {
      return null;
    }

    return { mainContentArea, sidebarArea, haveSidebar: !!sidebarArea?.length };
  });

  readonly postContentAreaSection = computed(() => applyRichTextFixes(this.content().postContentArea));
  readonly featuredAreaSection = computed(() => applyRichTextFixes(this.content().featuredArea));
}
